const locale = {
  PERSONAL: 'Personal Information',
  SKILLS: 'Update your skills',
  COURSES: 'Saved courses',
  PROFILE: 'Profile',
  PROFILE_NAV_ARIA_LABEL: 'Profile navigation ',
};

export default locale;
